export const SWRInfiniteHelper = {
  checkIsEmpty: (data) => {
    if (!Array.isArray(data)) return true

    const [first] = data
    if (typeof first !== 'object') return true
    if (!Array.isArray(first.data)) return true

    return first.data.length === 0
  },

  checkIsReachingEnd: (data) => {
    if (SWRInfiniteHelper.checkIsEmpty(data)) return true

    const [first] = data
    const dataOfAll = data.map(({ data }) => data).flat()

    return dataOfAll.length === first.total
  },
}
